import React, { Component, Fragment } from "react";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import { Modal, Button } from "shared/components";
import details from "../../assets/svg/detalhes.svg";
import styles from "./styles.css";

class ModalConfirmation extends Component {
  render() {
    const {
      t,
      isOpen,
      onCancel,
      onConfirm,
      onLoading,
      titleModal,
      item: { productName },
      messageParam,
    } = this.props;
    return (
      <Fragment>
        {!onLoading && (
          <Modal
            icon={details}
            title={titleModal}
            isOpen={isOpen}
            onClose={onCancel}
          >
            <p className={styles.confirmMessage}>
              {messageParam ? (
                <span>
                  {messageParam} <em>{productName}</em>
                </span>
              ) : (
                t("CONFIRM_ACTION")
              )}
            </p>
            <div className={styles.actions}>
              <Button relevance="low" onClick={onCancel}>
                {t("MSG_0056")}
              </Button>
              <Button
                type="submit"
                relevance="normal"
                callToAction
                onClick={onConfirm}
              >
                {t("CONFIRM")}
              </Button>
            </div>
          </Modal>
        )}
      </Fragment>
    );
  }
}

const enhance = compose(translate());

export default enhance(ModalConfirmation);



// WEBPACK FOOTER //
// ./src/components/ModalConfirmation/index.js